import { useState } from "react";
import { api, type User } from "../api";
import { BrandLockup } from "../components";

export function Login({ onLogin }: { onLogin: (user: User) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);

    try {
      onLogin(await api.login(email.trim(), password));
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível entrar.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="login" onSubmit={(e) => void submit(e)}>
      <BrandLockup className="brand-lockup" />

      {error && <div className="error">{error}</div>}

      <label>
        E-mail
        <input
          type="email"
          autoComplete="username"
          inputMode="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </label>

      <label>
        Senha
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </label>

      <button className="btn primary" type="submit" disabled={busy}>
        {busy ? "Entrando…" : "Entrar"}
      </button>

      <p className="note">
        Seu login é criado pelo administrador. Se esqueceu a senha, peça a
        redefinição — não há autocadastro.
      </p>
    </form>
  );
}
